// Libs
import React, { useState, useContext } from "react";
import { StoresContext, Stores } from "Globals/Stores";
import { useObserver, KeyValuePair, Grid, Else, Show, EditableInput } from "@shoothill/core";
import { Link as RouterLink } from "react-router-dom";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { RadioSVG } from "Globals/Views/IconSVGs/RadioSVG";
import { RadioCheckedSVG } from "Globals/Views/IconSVGs/RadioCheckedSVG";
import { Button, Table, TableHead, TableBody, TableRow, TableContainer, TableCell, Box, Radio, FormControl, FormHelperText, Select } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DateFnsUtils from "@date-io/date-fns";
import styled from "styled-components";
import { BinSVG } from "Globals/Views/IconSVGs/BinSVG";

// App
import { theme } from "Globals/Styles/AppTheme";
import PersonalDetailsViewModel from "Globals/ViewModels/FormSections/PersonalDetails/PersonalDetailsViewModel";
import PereviousAddressViewModel from "Globals/ViewModels/FormSections/PersonalDetails/PreviousAddressViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";

// Styles
import { StyledButton } from "Globals/Styles/ButtonStyles";
import { Row } from "Globals/Styles/LayoutStyles";
import { CustomDatePicker } from "Globals/Views/CustomDatePicker";

export const StyledAddButton = styled(StyledButton)`
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    padding: 0px;
    margin: 0 0 1px 0;
`;
interface IProps {
    personalDetailsViewModel: PersonalDetailsViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const PreviousAddressView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [upsertViewModel] = useState(() => new PereviousAddressViewModel());
    return useObserver(() => (
        <>
            <Box>
                {(upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving) == false && (
                    <>
                        <Row>
                            <EditableInput
                                label="Previous address line 1"
                                placeHolder="Address line 1"
                                viewModel={upsertViewModel}
                                fieldName="addressLine1"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <EditableInput
                                label="Previous address line 2"
                                placeHolder="Address line 2"
                                viewModel={upsertViewModel}
                                fieldName="addressLine2"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <EditableInput
                                label="Previous address line 3"
                                placeHolder="Address line 3"
                                viewModel={upsertViewModel}
                                fieldName="addressLine3"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                        </Row>
                        <Row>
                            <EditableInput
                                label="City/Town"
                                placeHolder="City/Town"
                                viewModel={upsertViewModel}
                                fieldName="city"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <EditableInput
                                label="Property county"
                                placeHolder="County"
                                viewModel={upsertViewModel}
                                fieldName="county"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <EditableInput
                                label="Postcode"
                                placeHolder="Postcode"
                                viewModel={upsertViewModel}
                                fieldName="postcode"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                        </Row>
                        <Row>
                            <Box>
                                <CustomDatePicker
                                    viewModel={upsertViewModel}
                                    label="Date from"
                                    placeholder={"from"}
                                    fieldName="fromDate"
                                    value={upsertViewModel.model.fromDate}
                                    onChange={(date: MaterialUiPickersDate) => {
                                        upsertViewModel.setDate("fromDate", date);
                                        props.personalDetailsViewModel.restartTimer();
                                    }}
                                    resetCallback={props.personalDetailsViewModel.restartTimer}
                                    disabled={upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving}
                                    maxDate={upsertViewModel.model.toDate}
                                />
                            </Box>
                            <Box>
                                <CustomDatePicker
                                    viewModel={upsertViewModel}
                                    label="Date to"
                                    placeholder={"to"}
                                    fieldName="toDate"
                                    value={upsertViewModel.model.toDate}
                                    onChange={(date: MaterialUiPickersDate) => {
                                        upsertViewModel.setDate("toDate", date);
                                        props.personalDetailsViewModel.restartTimer();
                                    }}
                                    resetCallback={props.personalDetailsViewModel.restartTimer}
                                    disabled={upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving}
                                    minDate={upsertViewModel.model.fromDate}
                                />
                            </Box>
                            <Box style={{ display: "flex", alignItems: "start", marginTop: "15px" }}>
                                <StyledAddButton
                                    variant="contained"
                                    disableElevation
                                    onClick={() => upsertViewModel.stash(props.personalDetailsViewModel)}
                                    disabled={upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving}
                                >
                                    +
                                </StyledAddButton>
                            </Box>
                        </Row>
                    </>
                )}
                {props.personalDetailsViewModel.getSortedPreviousAddressViewModels.length > 0 && (
                    <TableContainer>
                        <Table style={{ width: "100%" }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Address line 1</TableCell>
                                    <TableCell align="center">Address line 2</TableCell>
                                    <TableCell align="center">Address line 3</TableCell>
                                    <TableCell align="center">City/Town</TableCell>
                                    <TableCell align="center">County</TableCell>
                                    <TableCell align="center">Postcode</TableCell>
                                    <TableCell align="center">Date from</TableCell>
                                    <TableCell align="center">Date to</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.personalDetailsViewModel.getSortedPreviousAddressViewModels.map((previousAddress) => (
                                    <TableRow key={previousAddress.model.id}>
                                        <TableCell>{previousAddress.model.addressLine1}</TableCell>
                                        <TableCell align="center">{previousAddress.model.addressLine2}</TableCell>
                                        <TableCell align="center">{previousAddress.model.addressLine3}</TableCell>
                                        <TableCell align="center">{previousAddress.model.city}</TableCell>
                                        <TableCell align="center">{previousAddress.model.county}</TableCell>
                                        <TableCell align="center">{previousAddress.model.postcode}</TableCell>
                                        <TableCell align="center">{previousAddress.getFormattedFromDate}</TableCell>
                                        <TableCell align="center">{previousAddress.getFormattedToDate}</TableCell>
                                        <TableCell align="center">
                                            {(upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving) ==
                                                false && (
                                                <Button
                                                    onClick={() => {
                                                        previousAddress.delete(props.personalDetailsViewModel);
                                                    }}
                                                >
                                                    <BinSVG />
                                                </Button>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </>
    ));
};
